import * as Yup from 'yup'

export const MailLoginValidationSchema = Yup.object().shape({
  rpps: Yup.string()
    .required('Obligatoire')
    .matches(/^[0-9]{11}$/, '11 Chiffres uniquement'),
  password: Yup.string().required('Obligatoire'),
  otpMethod: Yup.string().required('Obligatoire'),
})
